const beneficios = [
  {
    icon: 'ri-tools-line',
    titulo: 'Sistema Sem Roldana',
    desc: 'Tecnologia articulada que elimina desgaste mecânico. Movimento suave e silencioso por décadas.',
  },
  {
    icon: 'ri-shield-check-line',
    titulo: 'NBR 7199 Garantida',
    desc: 'Projeto e instalação rigorosamente conforme a norma brasileira de vidros na construção civil.',
  },
  {
    icon: 'ri-award-line',
    titulo: 'Vidro Certificado',
    desc: 'Trabalhamos apenas com vidro temperado e laminado de fábricas certificadas — segurança comprovada.',
  },
  {
    icon: 'ri-calendar-check-line',
    titulo: 'Orçamento Travado',
    desc: 'Reserve hoje com 10% de sinal e o preço fica garantido por até 10 meses, sem reajuste.',
  },
  {
    icon: 'ri-team-line',
    titulo: 'Equipe Especializada',
    desc: 'Instaladores treinados e experientes. Mais de 200 sacadas entregues em São Paulo.',
  },
];

export default function Beneficios() {
  return (
    <section className="py-16 md:py-20 bg-stone-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
            POR QUE A THELUX
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-3">
            O envidraçamento da sua sacada merece o melhor
          </h2>
          <p className="text-stone-500 text-sm max-w-lg mx-auto">
            Não entregamos só vidro — entregamos tranquilidade, segurança e valorização do seu imóvel.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {beneficios.map((b) => (
            <div key={b.titulo} className="bg-white rounded-xl p-6 border border-stone-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-amber-50 text-amber-600 mb-4">
                <i className={`${b.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-stone-800 text-sm mb-2">{b.titulo}</h3>
              <p className="text-stone-500 text-xs leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}